export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/d3-format/src/identity.js
// module id = ../../../../d3-format/src/identity.js
// module chunks = 4